import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { LoadingComponent } from './ui-shared/loading/loading.component';
import { ErrorComponent } from './ui-shared/error/error.component';
import { WindowService } from './ui-shared/utils/window.service';
import { ButtonComponent } from './ui-shared/button/button.component';

import {
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { CompanyFormService } from './ui-crm/company-form/company-form.service';
import { ListContainerComponent } from './ui-shared/list-container/list-container.component';
import { IconComponent } from './ui-shared/icon/icon.component';
import { MultipleSelectComponent } from './ui-shared/multiple-select/multiple-select.component';
import { EmptyWarnComponent } from './ui-shared/empty-warn/empty-warn.component';
import { FormTemplateComponent } from './ui-shared/form-template/form-template.component';
import { PlusButtonComponent } from '../../shared/components/plus-button/plus-button.component';
import { FormSelectComponent } from './ui-shared/form-select/form-select.component';
import { FormDateComponent } from './ui-shared/form-date/form-date.component';
import { DialogComponent } from './ui-shared/dialog/dialog.component';
import { FormAnomaliesAutocompleteComponent } from './ui-shared/form-anomalies-autocomplete/form-anomalies-autocomplete.component';
import { FormPartsAutocompleteComponent } from './ui-shared/form-parts-autocomplete/form-parts-autocomplete.component';
import { ListComponent } from './ui-shared/list/list.component';
import { UploadImageComponent } from './ui-shared/upload-image/upload-image.component';
import { DialogSaveComponent } from './ui-shared/dialog-save/dialog-save.component';
import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import { FormAutocompleteComponent } from './ui-shared/form-autocomplete/form-autocomplete.component';
import { ChipsAutocompleteComponent } from './ui-shared/form-chips-autocomplete/form-chips-autocomplete.component';
import { MultipleSelectV2Component } from './ui-shared/multiple-select-v2/multiple-select-v2.component';
import { ButtonV2Component } from './ui-shared/button-v2/button-v2.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ContainerComponent } from './ui-shared/container/container.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DialogDocumentViewComponent } from './ui-shared/dialog-document-view/dialog.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DateAdapter } from '@angular/material/core';
import { FedDateAdapter } from './ui-shared/form-date/date-adapter.component';
import { InputImages } from './ui-shared/drop-input/input-images.component';
import { DefaultDialogComponent } from './ui-shared/default-dialog/default-dialog.component';
import { AppPageDirective } from './app-page.directive';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AssigneesIconListComponent } from './ui-shared/assignees-icon-list/assignees-icon-list.component';
import { UserProfileImageComponent } from './ui-shared/image/user-profile-image.component';
import { AvatarModule } from 'ngx-avatars';
import { TableComponent } from './ui-shared/table/table.component';
import { PaginatorComponent } from '@fullyops/shared/components/paginator/component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@fullyops/shared/shared.module';
import { ExpansionPanelComponent } from '@fullyops/shared/components/expansion-panel/expansion-panel.component';
import { MatChipsModule } from '@angular/material/chips';
import { SidenavFormContainerComponent } from '@fullyops/legacy/ui/ui-shared/sidenav-form-container/sidenav-form-container.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CdkMenu } from '@angular/cdk/menu';
import { FoBreadcrumbComponent } from '@fullyops/shared/components/breadcrumb/fo-breadcrumb.component';
import { DateTimeInputComponent } from '@fullyops/shared/components/date-time-input/date-time-input.component';

@NgModule({
  declarations: [
    DialogSaveComponent,
    UploadImageComponent,
    FormAnomaliesAutocompleteComponent,
    FormPartsAutocompleteComponent,
    DialogComponent,
    DialogDocumentViewComponent,
    DefaultDialogComponent,
    LoadingComponent,
    ErrorComponent,
    IconComponent,
    MultipleSelectComponent,
    ButtonComponent,
    ListContainerComponent,
    EmptyWarnComponent,
    FormTemplateComponent,
    FormSelectComponent,
    FormDateComponent,
    AppPageDirective,
    ListComponent,
    FormAutocompleteComponent,
    ChipsAutocompleteComponent,
    MultipleSelectV2Component,
    ButtonV2Component,
    ContainerComponent,
    InputImages,
    AssigneesIconListComponent,
    UserProfileImageComponent,
    TableComponent,
    SidenavFormContainerComponent,
  ],
  exports: [
    DialogSaveComponent,
    UploadImageComponent,
    FormAnomaliesAutocompleteComponent,
    FormPartsAutocompleteComponent,
    I18NextModule,
    FoBreadcrumbComponent,
    DialogComponent,
    DialogDocumentViewComponent,
    DefaultDialogComponent,
    LoadingComponent,
    ErrorComponent,
    IconComponent,
    MultipleSelectComponent,
    ButtonComponent,
    ListContainerComponent,
    EmptyWarnComponent,
    FormTemplateComponent,
    FormSelectComponent,
    FormDateComponent,
    AppPageDirective,
    ListComponent,
    FormAutocompleteComponent,
    ChipsAutocompleteComponent,
    MultipleSelectV2Component,
    ButtonV2Component,
    ContainerComponent,
    InputImages,
    ExpansionPanelComponent,
    AssigneesIconListComponent,
    UserProfileImageComponent,
    TableComponent,
    RouterModule,
    SidenavFormContainerComponent,
    PlusButtonComponent,
  ],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FullCalendarModule,
    FontAwesomeModule,
    ClipboardModule,
    NgxExtendedPdfViewerModule,
    MatMomentDateModule,
    InfiniteScrollModule,
    AvatarModule,
    RouterModule,
    SharedModule,
    MatChipsModule,
    CdkConnectedOverlay,
    CdkOverlayOrigin,
    CdkMenu,
    FoBreadcrumbComponent,
    PaginatorComponent,
    PlusButtonComponent,
    DateTimeInputComponent,
    ExpansionPanelComponent,
  ],
  providers: [
    WindowService,
    CompanyFormService,
    { provide: DateAdapter, useClass: FedDateAdapter },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class UiModule {}
